import React, { Component, Fragment } from 'react';
import { NavLink, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Opinion } from './Opinion';
import Form from 'react-bootstrap/lib/Form';
import map from 'lodash.map';
import filter from 'lodash.filter';
import find from 'lodash.find';
import findIndex from 'lodash.findindex';
import isEmpty from 'lodash.isempty';
import isEqual from 'lodash.isequal';
import SVG from 'react-inlinesvg';
import {
	ProjectType,
	ImageMimeType,
	ProjectStatus,
	ConsultationFormStatus,
	ProjectMode,
	ConsultationFormType
} from '../../../utils/enums';
import { replaceEndOfLine } from '../../../utils/text-extensions';
import { RouteUrls } from '../../../configs/routeUrls';
import { ProjectInfo } from './ProjectInfo';
import { transformSVG } from '../../../utils/svg-extensions';

export class ProjectCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			agreementAccepted: props.agreementAccepted || false,
			showAgreementError: false,
			isVoted: this.isVoted(),
			countOfDistricts: this.countDistricts(),
			countOfProjects: this.countProjects(),
			openEmail: false,
			openPostAddress: false
		};
		this.agreement = null;

		this.handleClickAttachments = (content, contentType) => {
			window.open(`data:${contentType};base64,${content}`);
		};
		this.replaceEndOfLine = replaceEndOfLine.bind(this);

		this.onChangeAgreementAccepted = (e) => {
			this.setState({
				agreementAccepted: e.target.checked,
				showAgreementError: !e.target.checked
			});
			this.props.onChangeAgreementAccepted(e);
		};
	}

	componentDidUpdate(prevProps) {
		if (prevProps.agreementAccepted !== this.props.agreementAccepted) {
			this.setState({
				agreementAccepted: this.props.agreementAccepted
			});
		}
		if (!isEqual(prevProps.consultationForms, this.props.consultationForms)) {
			this.setState({
				isVoted: this.isVoted(),
				countOfDistricts: this.countDistricts(),
				countOfProjects: this.countProjects()
			});
		}
		if (!isEqual(prevProps.openEmailForm, this.props.openEmailForm)) {
			this.setState({
				openEmail: this.props.openEmailForm
			});
		}
	}

	isVoted() {
		if (this.props.type === ProjectType.PublicBudget) {
			return this.props.consultationForms && this.props.consultationForms.length > 0
				? this.props.consultationForms.some((item) => item.voted)
				: false;
		}
		const consultationFormToVoteMode = filter(
			this.props.consultationForms,
			(form) => form.type === ConsultationFormType.Probe || form.type === ConsultationFormType.Survey
		);

		if (!isEmpty(consultationFormToVoteMode) && this.props.type === ProjectType.Consultation) {
			return consultationFormToVoteMode.every((item) => item.voted);
		}
		return !isEmpty(consultationFormToVoteMode) ? consultationFormToVoteMode.some((item) => item.voted) : false;
	}

	countDistricts = () =>
		this.props.type === ProjectType.PublicBudget && !isEmpty(this.props.consultationForms)
			? this.props.consultationForms ? this.props.consultationForms.length : 0
			: 0;

	countProjects = () =>
		this.props.type === ProjectType.PublicBudget && !isEmpty(this.props.consultationForms)
			? this.props.consultationForms.reduce(
					(totalProjects, currConsultationForm) =>
						totalProjects +
						currConsultationForm.categories.reduce(
							(prevCategory, currCategory) => prevCategory + currCategory.questions.length,
							0
						),
					0
				)
			: 0;

	renderAttachmentsIcon(type) {
		switch (type) {
			case 'application/pdf': {
				return <i className="fas fa-file-pdf attachments-list__icon attachments-list__icon--primary-dark" />;
			}
			default: {
				return <i className="fas fa-file attachments-list__icon attachments-list__icon--primary-dark" />;
			}
		}
	}

	scrollToAgreement() {
		this.setState({
			showAgreementError: true
		});
		this.agreement.scrollIntoView(false);
	}

	calculateTotalComments(childrens, total = 0) {
		return childrens.reduce((prev, curr) => {
			let childrenComments = 0;
			if (!isEmpty(curr.childrens)) {
				childrenComments = this.calculateTotalComments(curr.childrens);
			}
			return prev + curr.comments.length + childrenComments;
		}, total);
	}

	toggleAddress = (name) => {
		if (name === 'openEmail') {
			this.setState({
				openEmail: !this.state.openEmail,
				openPostAddress: false
			});
			this.props.getContactForm(!this.state.openEmail, false);
		} else {
			this.setState({
				openEmail: false,
				openPostAddress: !this.state.openPostAddress
			});

			this.props.getContactForm(false, !this.state.openPostAddress);
		}
	};

	render() {
		const { isVoted, countOfDistricts, countOfProjects } = this.state;
		const {
			id,
			consultationTitle,
			dateFrom,
			dateTo,
			statusName,
			moderatorName,
			votedForAllForms,
			commentAdded,
			description,
			attachments,
			resultAttachments,
			isAuth,
			mode,
			modeName,
			thematicAreaName,
			title,
			type,
			isLegalAgeUser,
			onlyForLegalAge,
			thumbImageContentType,
			thumbImage,
			isOnlyOneOffice,
			officeName,
			canSetProjectOpinion,
			budgetYearValue,
			disabled,
			agreementAccepted,
			actualAgreementAccepted,
			agreementHistory,
			status,
			voteForms,
			availableVoteForms,
			isParticipate,
			consultationForms
		} = this.props;

		const socialGroupNames = map(this.props.socialGroups, (socialGroup) => socialGroup.socialGroupName);
		const socialGroupsText = socialGroupNames.length > 0 ? socialGroupNames.join(', ') : '';
		let totalComments = this.props.comments ? this.props.comments.length : 0;
		if (this.props.act && !isEmpty(this.props.act.childrens)) {
			totalComments = this.calculateTotalComments(this.props.act.childrens, totalComments);
		}
		const postAddress = find(consultationForms, { type: ConsultationFormType.PostAddress });
		const emailAddress = find(consultationForms, { type: ConsultationFormType.EmailAddress });
		const showOpinion = findIndex(consultationForms, (cf) => cf.type === ConsultationFormType.Opinion) !== -1;

		return (
			<Fragment>
				<div className="consultations__item consultations__item--no-margins consultations__item--no-padding">
					<div className="consultations__header">
						<div className="consultations__title">{title}</div>
						<div className="consultations__icons">
							{type === ProjectType.PublicBudget && (
								<Fragment>
									<Link
										to={RouteUrls.Budget.pages.prerequisiteFunc(budgetYearValue)}
										title="Do pobrania"
										target="_blank"
									>
										<i className="link link__icon link__icon-biggest link__icon-left link--primary-dark fas fa-download" />
									</Link>
									<Link
										to={RouteUrls.Budget.pages.scheduleFunc(budgetYearValue)}
										title="Harmonogram"
										target="_blank"
									>
										<i className="link link__icon link__icon-biggest link__icon-left link--primary-dark fas fa-calendar-alt" />
									</Link>
									<Link
										to={RouteUrls.Budget.pages.helpFunc(budgetYearValue)}
										title="Pomoc"
										target="_blank"
									>
										<i
											className={`link link__icon link__icon-biggest link--primary-dark fas fa-question-circle`}
										/>
									</Link>
								</Fragment>
							)}
						</div>
					</div>
					<div className="consultations__body">
						<div className="consultation-item consultation-item-no-shadow consultation-item-no-border">
							<div className="consultation-item__body">
								<div className="consultation-item__desc margin-right-20 row row--column">
									{false &&
									type === ProjectType.Consultation && (
										<div className="consultation-description__thumbnail">
											{thumbImageContentType !== ImageMimeType.SVG && (
												<div className="svg-container">
													<img
														className="thumbnail__content"
														src={`data:image/jpeg;base64, ${thumbImage}`}
													/>
												</div>
											)}
											{thumbImageContentType === ImageMimeType.SVG && (
												<div className="svg-container">
													<SVG
														src={transformSVG(
															thumbImage,
															`svg-project-${id}`,
															`Zdjęcie dla ${title}`
														)}
													/>
												</div>
											)}
										</div>
									)}
									<div
										className="consultation-description__text"
										dangerouslySetInnerHTML={{ __html: this.replaceEndOfLine(description) }}
									/>
									{postAddress && (
										<div className="margin-top-20">
											<div className="consultation__title margin-top-30 margin-bottom-15">
												Adres korespondencyjny
											</div>
											<div
												className="consultation-description__text"
												dangerouslySetInnerHTML={{ __html: postAddress.postAddress }}
											/>
										</div>
									)}
								</div>
								<div>
									<ProjectInfo
										{...{
											type,
											thematicAreaName,
											dateFrom,
											dateTo,
											modeName,
											onlyForLegalAge,
											isAuth,
											isVoted,
											availableVoteForms,
											voteForms,
											isParticipate,
											isOnlyOneOffice,
											officeName,
											countOfDistricts,
											countOfProjects
										}}
									/>
									{!isEmpty(agreementHistory) && (
										<div
											className="consultation-item__agreement"
											ref={(ref) => (this.agreement = ref)}
										>
											<label className="checkbox">
												{((isAuth &&
													[ ProjectMode.Close, ProjectMode.Citizen ].includes(mode)) ||
													mode === ProjectMode.Open) &&
												(type === ProjectType.Consultation
													? !isEmpty(
															filter(
																consultationForms,
																(cf) => cf.type !== ConsultationFormType.PostAddress
															)
														)
													: true) &&
												status === ProjectStatus.Active && (
													<input
														className="checkbox__input"
														type="checkbox"
														disabled={
															disabled ||
															(agreementAccepted &&
																agreementAccepted === actualAgreementAccepted)
														}
														id="agreementAccepted"
														name="agreementAccepted"
														value={this.state.agreementAccepted}
														checked={this.state.agreementAccepted}
														onChange={this.onChangeAgreementAccepted}
													/>
												)}
												<span className="row row--align-center row--nowrap">
													{((isAuth &&
														[ ProjectMode.Close, ProjectMode.Citizen ].includes(mode)) ||
														mode === ProjectMode.Open) &&
													(type === ProjectType.Consultation
														? !isEmpty(
																filter(
																	consultationForms,
																	(cf) => cf.type !== ConsultationFormType.PostAddress
																)
															)
														: true) &&
													status === ProjectStatus.Active && (
														<span className="checkbox__button checkbox__button-left margin-right-5">
															<span className="checkbox__button-checkbox" />
														</span>
													)}
													<span className="text">
														{agreementHistory.title}

														<NavLink
															to={`${RouteUrls.App.termOfUse}/${agreementHistory.id}`}
															className="link"
															target="_blank"
															title="Szczegóły regulaminu"
														>
															<i
																className="far fa-clone link__icon margin-left-10"
																aria-hidden="true"
															/>
														</NavLink>
													</span>
												</span>
											</label>
											{!this.state.agreementAccepted &&
											this.state.showAgreementError &&
											!isEmpty(agreementHistory) && (
												<Form.Control.Feedback
													type="invalid"
													style={{ display: 'block', color: 'red', marginTop: 10 }}
												>
													Wymagana akceptacja regulaminu
												</Form.Control.Feedback>
											)}
										</div>
									)}
								</div>
							</div>
							<div className="consultation-item__row consultation-item__row--justify-space margin-top-20">
								{type === ProjectType.Consultation && (
									<Fragment>
										<div className="consultation-item__row consultation-item__row--thumb-buttons consultation-item__row--justify-end">
											<div className="row row--justify-space row--align-center row--width-full text text--weight-500">
												<div>
													{emailAddress && (
														<a
															disabled={!canSetProjectOpinion || (onlyForLegalAge && !isLegalAgeUser)}
															className={`link link--primary-dark link__icon-left link__icon--extra-large row row--align-center`}
															onClick={this.toggleAddress.bind(this, 'openEmail')}
															title={`${disabled
																? 'Nieaktywny formularz do wysłania wypowiedzi'
																: `${this.props.openEmailForm
																		? 'Ukryj'
																		: 'Pokaż'} formularz do wysłania wypowiedzi`}`}
														>
															<i className={`fas fa-at`} />
															<span className="text text--weight-500 margin-left-10">
																Kontakt e-mail
															</span>
														</a>
													)}
												</div>
												{showOpinion && (
													<div>
														<span className="margin-right-10">Czy zgadzasz się?</span>
														<Opinion
															commentObjectId={this.props.id}
															likeCount={this.props.projectLikeCount}
															unlikeCount={this.props.projectUnlikeCount}
															userLikeCount={this.props.userProjectLikeCount}
															userUnlikeCount={this.props.userProjectUnlikeCount}
															userOpinionId={this.props.userProjectOpinionId}
															addOpinion={(id, type) =>
																this.props.addProjectOpinion(id, type)}
															removeOpinion={(id) => this.props.removeProjectOpinion(id)}
															opinionExecuting={this.props.opinionExecuting}
															comments={true}
															disabled={!canSetProjectOpinion || (onlyForLegalAge && !isLegalAgeUser)}
															agreementAccepted={this.props.actualAgreementAccepted}
															agreementAcceptedRequired={
																this.props.agreementAcceptedRequired
															}
															scrollToAgreement={this.props.scrollToAgreement}
														/>
													</div>
												)}
											</div>
										</div>
										{false &&
										!isEmpty(
											filter(consultationForms, (cf) => cf.type === ConsultationFormType.Comment)
										) && (
											<div className="row text text--weight-500">
												<Link
													to={RouteUrls.Comment.listFunc(id)}
													className="button button--primary-dark button--width-auto link link--size-15"
													title={`Przejdź do wszystkich komentarzy`}
													disabled={true}
												>{`Przejdź do wszystkich komentarzy (${totalComments})`}</Link>
											</div>
										)}
									</Fragment>
								)}
							</div>
						</div>
					</div>
				</div>
			</Fragment>
		);
	}
}

ProjectCard.defaultProps = {
	id: 0,
	dateFrom: moment().format('YYYY-MM-DD'),
	dateTo: moment().format('YYYY-MM-DD'),
	statusName: '',
	moderatorName: '',
	votedForAllForms: false,
	commentAdded: false,
	description: '',
	attachments: [],
	resultAttachments: [],
	isAuth: false,
	modeName: '',
	thematicAreaName: '',
	title: '',
	type: 0,
	onlyForLegalAge: false,
	thumbImageContentType: '',
	thumbImage: '',
	isOnlyOneOffice: false,
	officeName: '',
	canSetProjectOpinion: false,
	budgetYearValue: 0,
	disabled: true,
	agreementAccepted: false,
	agreementHistory: null,
	status: ConsultationFormStatus.Active,
	voteForms: 0,
	availableVoteForms: 0,
	act: {
		childrens: []
	},
	projectLikeCount: 0,
	projectUnlikeCount: 0,
	shortDescription: '',
	userProjectLikeCount: 0,
	userProjectUnlikeCount: 0,
	userProjectOpinionId: 0,
	opinionExecuting: [],

	addProjectOpinion: Function.prototype,
	removeProjectOpinion: Function.prototype
};
ProjectCard.propTypes = {
	act: PropTypes.shape({
		childrens: PropTypes.arrayOf(PropTypes.object)
	}),
	canSetProjectOpinion: PropTypes.bool,
	dateFrom: PropTypes.string,
	dateTo: PropTypes.string,
	description: PropTypes.string,
	disabled: PropTypes.bool,
	id: PropTypes.number,
	modeName: PropTypes.string,
	moderatorName: PropTypes.string,
	projectLikeCount: PropTypes.number,
	projectUnlikeCount: PropTypes.number,
	shortDescription: PropTypes.string,
	statusName: PropTypes.string,
	thematicAreaName: PropTypes.string,
	title: PropTypes.string,
	type: PropTypes.number,
	userProjectLikeCount: PropTypes.number,
	userProjectUnlikeCount: PropTypes.number,
	userProjectOpinionId: PropTypes.number,

	addProjectOpinion: PropTypes.func,
	removeProjectOpinion: PropTypes.func
};
